import React from 'react';

const Error410Page = () => {
  const containerStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    backgroundColor: '#ffffff',
    color: '#333333',
    textAlign: 'center',
    padding: '20px',
    fontFamily: '"Segoe UI", Tahoma, Geneva, Verdana, sans-serif',
  };

  const codeStyle = {
    fontSize: '96px',
    fontWeight: 'bold',
    color: '#d32f2f',
    margin: 0,
  };

  const titleStyle = {
    fontSize: '28px',
    fontWeight: '600',
    margin: '20px 0 10px',
  };

  const messageStyle = {
    fontSize: '16px',
    maxWidth: '500px',
    lineHeight: '1.6',
  };

  const buttonStyle = {
    marginTop: '30px',
    padding: '10px 20px',
    backgroundColor: '#1976d2',
    color: '#ffffff',
    border: 'none',
    borderRadius: '4px',
    fontSize: '16px',
    cursor: 'pointer',
    textDecoration: 'none',
  };

  const handleBack = () => {
    window.location.href = '/';
  };

  return (
    <div style={containerStyle}>
      <h2 style={titleStyle}>This page is no longer available</h2>
      <p style={messageStyle}>
        The resource you are looking for has been permanently removed and is no longer accessible.
        If you believe this is an error, please contact support or return to the homepage.
      </p>
      <button onClick={handleBack} style={buttonStyle}>
        Go to Homepage
      </button>
    </div>
  );
};

export default Error410Page;
